const apiBaseUrl = 'https://wordpress.koblenzkompass.de/wp-json/wp/v2/posts?categories=';
const apiRequestLimit = '&per_page=100';
export const apiRoutes = {
	NEWS: apiBaseUrl + '3' + apiRequestLimit,
	DISCOVER_ALL: apiBaseUrl + '2' + apiRequestLimit,
	SINGLE_ARTICLE: apiBaseUrl + '2&slug=',
	CITY_RUMORS: apiBaseUrl + '29' + apiRequestLimit
};


// WEBPACK FOOTER //
// ./src/config-data/apiRoutes.js